/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { SaasUserTrial } from '@modules/cloud-api/v1/types'

import { getUTCDate } from './date'

export function getDaysLeftInBillingCycle(): number {
  const numberOfDaysInMonth = getUTCDate().daysInMonth()
  const numberOfDaysPassed = getUTCDate().date()
  return numberOfDaysInMonth - numberOfDaysPassed
}

export function trialNotStarted({
  inTrial,
  trials,
}: {
  inTrial?: boolean
  trials: SaasUserTrial[]
}): boolean {
  if (typeof inTrial === 'undefined') {
    return true
  }

  return inTrial && !trials.length
}
